<template>
  <div class="swiper-card card-switch-off">
    <transition-group
      name="fade-slide-bottom"
      tag="div"
      v-if="reveal"
      class="reveal-group"
      appear
    >
      <div :key="'lottie'" class="lottie">
        <Lottie ref="lottie" animation="switch-off" :relative="true" />
      </div>
      
      <h3 :key="'title-wrapper'">{{ slide.content.title }}</h3>
      <p :key="'byline-wrapper'">{{ slide.content.byline }}</p>

      <div :key="'dial'" class="dial">
        <UserTrack :size="120" :focus="getDialFocus" />
      </div>
    </transition-group>
  </div>
</template>

<script>
  import Lottie from '@/components/v5/Lottie.vue';
  import UserTrack from '@/components/v5/elements/UserTrack.vue';

  export default {
    data() {
      return {
        reveal: false
      }
    },

    props: {
      slide: {
        type: Object,
      },
    },

    components: {
      Lottie,
      UserTrack
    },

    mounted () {
      this.$watch('$route.params.stack', (slug) => {
        if (slug === this.slide.slug) {
          this.$emit('swiperUpdate');
          this.$emit('enableNextAction');
          setTimeout(() => {
            this.play();
          }, 500);
        }
      }, { immediate: true });
    },

    computed: {
      getFocus() {
        return this.$userEngine.dialFocus;
      },

      getDialFocus() {
        return ['time','topics','locales'].includes(this.getFocus) ? this.getFocus : null;
      },
    },

    methods: {
      play() {
        this.reveal = true;
        
        setTimeout(() => {
          this.$refs.lottie?.play();
        }, 50);
      }
    },
  }
</script>

<style lang="scss" scoped>
  @import 'src/assets/scss/v5_stacks.scss';

  .card-switch-off {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 70vh;
    padding: 0 1rem;
    text-align: center;

    .lottie {
      margin-bottom: 2rem;
    }

    h3 {
      font-family: 'Circular';
      font-weight: bold;
      font-size: 1.75rem;
      margin: 0 0 0.5rem 0;
    }

    p {
      font-family: 'Circular';
      font-size: 1.1rem;
    }

    .dial {
      margin-top: 2rem;
    }
  }

  .reveal-group > *:nth-child(2) {
    transition-delay: 0.10s;
  }
  .reveal-group > *:nth-child(3) {
    transition-delay: 0.25s;
  }
  .reveal-group > *:nth-child(4) {
    transition-delay: 0.40s;
  }
</style>

<style lang="scss">
.fade-slide-bottom-enter-active {
  transition: all 0.5s ease;
}
.fade-slide-bottom-enter {
  opacity: 0;
  transform: translateY(50px);
}
.fade-slide-bottom-enter-to {
  opacity: 1;
  transform: translateY(0);
}
</style>